import Client from "./client";

// A project's support email settings. The stored mail password is never
// returned by any of these - the API reports `has_mail_password` and nothing
// more (see api/lib/supportEmail.js's serializeSupportEmail).

export const GetSupportEmail = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get(`/api/projects/${projectId}/support-email`, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve({supportEmail: res.data.support_email, entitlement: res.data.entitlement});
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// `mailPassword` is write-only, and the three cases are distinct: leave it out
// to keep whatever is stored, send a string to replace it, send "" to remove
// it.
export const UpdateSupportEmail = ({projectId, mode, fromName, smtpHost, smtpPort, smtpSecure, smtpFromEmail, mailUser, mailPassword, inboundEnabled, imapHost, imapPort, imapSecure, imapFolder, accessToken}) => {
    const data = {mode};
    if (fromName !== undefined) data.fromName = fromName;
    if (smtpHost !== undefined) data.smtpHost = smtpHost;
    if (smtpPort !== undefined) data.smtpPort = smtpPort;
    if (smtpSecure !== undefined) data.smtpSecure = smtpSecure;
    if (smtpFromEmail !== undefined) data.smtpFromEmail = smtpFromEmail;
    if (mailUser !== undefined) data.mailUser = mailUser;
    if (mailPassword !== undefined) data.mailPassword = mailPassword;
    if (inboundEnabled !== undefined) data.inboundEnabled = inboundEnabled;
    if (imapHost !== undefined) data.imapHost = imapHost;
    if (imapPort !== undefined) data.imapPort = imapPort;
    if (imapSecure !== undefined) data.imapSecure = imapSecure;
    if (imapFolder !== undefined) data.imapFolder = imapFolder;

    return new Promise((resolve, reject) => {
        Client.put(`/api/projects/${projectId}/support-email`, data, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.support_email);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}

// Sends a real message to the signed-in user's own address - the only way to
// find out whether a mail server accepts the credentials. Resolves with
// {sent, transport, error, to}: a refusal by the mail server is a result here,
// not a rejected promise.
export const TestSupportEmail = ({projectId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/projects/${projectId}/support-email/test`, {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject({
                ...(e.response?.data || { error: "Something went wrong. Please try again." }),
                status: e.response?.status,
            });
        })
    })
}
